import { combineReducers } from "redux";
import { terrainSlice } from "./terrain";
import { mapSlice } from "./map";

export const reducer = combineReducers({
    [terrainSlice.reducerPath]: terrainSlice.reducer,
    [mapSlice.reducerPath]: mapSlice.reducer,
});